import { Answer, Question, QuestionnaireService } from "@/types/questionnaire"
import { useState } from "react";
import parse from 'html-react-parser';
import BaseCheckbox from "./BaseCheckbox";
import SubAnswer from "./SubAnswer";


interface Properties {
    parentAnswer: Answer,
    question: Question,
    setQuestionCompleted: (completed: boolean) => any
}

function QuestionMultiple(properties: Properties) {
    const {parentAnswer, question, setQuestionCompleted} = {...properties};
    const subAnswers: Answer[] = question.answers;
    
    const [completedSubAnswers, initialCompleted] = (() => {
        let completed: number = 0;
        let initialCompleted: boolean[] = new Array(subAnswers.length);
        for(const index in subAnswers) {
            initialCompleted[index] = QuestionnaireService.AnswerIsCompleted(subAnswers[index]);
            completed += initialCompleted[index] ? 1 : 0;
        }
        return [completed, initialCompleted];
    })();  
    const [subQuestionCompleted, setSubQuestionCompleted] = useState<boolean[]>(initialCompleted);

    const setSubAnswerCompleted = function(index: number, subAnswerCompleted: boolean) {
        console.log(index, subAnswerCompleted);
        if( subQuestionCompleted[index] === subAnswerCompleted ) return;

        const newValues: boolean[] = [...subQuestionCompleted];
        newValues[index] = subAnswerCompleted;
        setSubQuestionCompleted(newValues);

        const newCompletedSubAnswers: number = completedSubAnswers + (subAnswerCompleted ? 1 : -1);
        subAnswers[index].checked = subAnswerCompleted;
        setQuestionCompleted( newCompletedSubAnswers >= subAnswers.length);
    }

    const renderAnswerTitle = function(answer: Answer) {
        if( answer.title && answer.description ) {
            return <>
                <h4>{ answer.title }</h4>
                <h5>{ answer.description }</h5>
            </>
        }
        return <>
        <h4>{ QuestionnaireService.AnswerGetContent(parentAnswer) }</h4>
        </>
    }

    const onClickCheckbox = function(index: number) {
        console.log("onclick checkbox");
    }

    return (
        <>
            <h4 className="em-sec-color">{ parse(QuestionnaireService.AnswerGetContent(parentAnswer))}</h4>
            <p className="text-lg mt-2">{parse(question.title)}</p>
            <div className="mt-3 overflow-auto flex-initial">
            { subAnswers.map((answer: Answer, index: number) =>
                <div key={answer.id} className="subanswers">               
                    { answer.questions && (
                        <>
                        <SubAnswer answer={answer} setSubAnswerCompleted={setSubAnswerCompleted.bind(null, index)} />
                        </>
                    )}
                    { answer.questions == null && (
                    <>
                        <label
                            className={`flex-1 flex flex-row pt-2 pb-2 gap-3 bg-white text-xl items-center cursor-pointer`}
                        >
                            <BaseCheckbox
                                className="cursor-pointer"
                                checked={answer.checked}
                                onChange={() => onClickCheckbox(index)}
                            />
                            <h5 className="flex-1 text-xl font-normal">{ QuestionnaireService.AnswerGetContent(answer) }</h5>
                        </label>
                    </>)}
                </div>
            )}
            </div>
        </>
    )
}

export default QuestionMultiple